import { useCallback, useMemo } from "react";

import { Button } from "@/components/ui/button/button";

type Props = {
	isDirty: boolean;
	hasError: boolean;
	onClickCallback: () => Promise<void>;
};

export const UpdateButton = ({ isDirty, hasError, onClickCallback }: Props) => {
	/**
	 * 押下時の処理
	 */
	const handleClick = useCallback(async () => await onClickCallback(), [onClickCallback]);

	const isValid = useMemo(() => isDirty && !hasError, [isDirty, hasError]);

	return (
		<Button onClick={handleClick} type="button" size="xl" variant={isValid ? "default" : "disabled"}>
			保存
		</Button>
	);
};
